/**
 * Generates a resized image URL for the Springbig CDN, given width and height in pixels.
 *
 * @param originalUrl - The original CDN image URL.
 * @param h - The height in **pixels**.
 * @param w - The width in **pixels**.
 * @param fit - resizeMode.
 * @returns A resized image URL with the specified dimensions.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    resizedUrl: ()=>resizedUrl,
    validateEmail: ()=>validateEmail,
    pluralize: ()=>pluralize,
    IMG_URL: ()=>IMG_URL,
    CONFIG_URL: ()=>CONFIG_URL,
    fakeItemsArray: ()=>fakeItemsArray,
    typographyRegex: ()=>typographyRegex,
    isImageUrl: ()=>isImageUrl
});
_exportStar(require("./config"), exports);
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
function resizedUrl(originalUrl, h, w, fit) {
    // temp solution until resize lambda issue is fixed
    return originalUrl;
    const shouldResize = h && w;
    if (!originalUrl || !originalUrl.startsWith('https://cdn.springbig.cloud/') || !shouldResize) {
        return originalUrl;
    }
    const urlWithoutDomain = originalUrl.replace('https://cdn.springbig.cloud/', '');
    const baseResizedUrl = `https://cdn.springbig.cloud/resize/${urlWithoutDomain.split('?')[0]}`;
    const filteredParams = Object.fromEntries(Object.entries({
        h,
        w
    }).filter(([_, v])=>v !== undefined && v !== null).map(([k, v])=>[
            k,
            String(v)
        ]));
    const query = new URLSearchParams({
        ...filteredParams,
        fit: fit || 'cover'
    }).toString();
    return `${baseResizedUrl}?${query}`;
}
const validateEmail = (email)=>{
    // Simple email validation using regular expression
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
};
const pluralize = (quantity, word)=>{
    return word + (quantity || 0 > 1 ? 's' : '');
};
const IMG_URL = 'https://dmzzpbgwwctnn.cloudfront.net';
const CONFIG_URL = 'https://d1fzvegns2c9no.cloudfront.net';
const fakeItemCount = 10;
const fakeItemsArray = Array.from({
    length: fakeItemCount
}, (_, index)=>index);
const typographyRegex = /(\{i\}|\{\/i\}|\{b\}|\{\/b\}|\{c:\d+\}|\{\/c:\d+\}|\{s:\d+\}|\{\/s:\d+\})/g;
const isImageUrl = (url)=>/(\.png|\.jpg|\.jpeg)$/i.test(url);
